import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import { commonStore } from './commonStore';
import LocalStorageService from './LocalStorageService';
import webAppConfig from '../commons/webApp.config';

const getInitialState = () => ({
  ...commonStore.state,
  workspace: {}
});

export const devicePreviewStore = new Vuex.Store({
  state: getInitialState(),
  mutations: {
    setWorkspace(state, data) {
      $cookies.set('wsId', data.id);
      LocalStorageService.setWorkspaceId(webAppConfig.baseServer, data.id);
      state.workspace = data;
      state.client.defaults.headers['wsId'] = data.id;
    }
  },
  actions: {
    async loadWorkspace({ state, commit }, payload = {}) {
      const workspaceId = payload.id; 
      const res = await state.client.get(`/api/workspace/${workspaceId}`);

      commit('setWorkspace', res.data);
    }
  },
  getters: {
    workspaceId: state => state.workspace && state.workspace.id,
    workspaceModules: state => state.workspace && state.workspace.vectors,
    workspaceUsers: state => state.workspace && state.workspace.users
  }
});